import MainMenu from "./MainMenu";
import React from "react";
import HallOfFameDuck from "./HallOfFameDuck";

export default function HallOfFame() {
    return (
        <div style={{display: "flex", flexDirection: "row"}}>
            <MainMenu/>
            <div style={{width: '660px', padding: '40px 0px 0px 70px'}}>
                <div style={{fontSize: '30px', marginBottom: '20px'}}>
                    Hall of Fame
                </div>
                <div className='flexColumn' style={{justifyContent: 'flex-start', marginBottom: '40px'}}>
                    <div style={{fontSize: '30px', fontWeight: 'bold'}}>
                        June 2022
                    </div>
                    <div className='flexRow' style={{gap: '25px'}}>
                        <div><HallOfFameDuck nft={975} placing={1} wins={25} title={'Boss Duck'} revshare={0.051}/></div>
                        <div><HallOfFameDuck nft={1619} placing={2} wins={24} title={'Tough Duck'} revshare={0.0306}/></div>
                        <div><HallOfFameDuck nft={383} placing={3} wins={20} title={'Sly Duck'} revshare={0.0204}/></div>
                    </div>
                </div>
                <div className='flexColumn' style={{justifyContent: 'flex-start'}}>
                    <div style={{fontSize: '30px', fontWeight: 'bold'}}>
                        May 2022
                    </div>
                    <div className='flexRow' style={{gap: '25px'}}>
                        <div><HallOfFameDuck nft={383} placing={1} wins={59} title={'Mafia Duck'} revshare={0.06825}/></div>
                        <div><HallOfFameDuck nft={5051} placing={2} wins={43} title={'Hitman Duck'} revshare={0.04095}/></div>
                        <div><HallOfFameDuck nft={348} placing={3} wins={40} title={'Don Duck'} revshare={0.0273}/></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
